import { render, staticRenderFns } from "./TmsIndex.vue?vue&type=template&id=6f79c4d0"
import script from "./TmsIndex.ts?vue&type=script&lang=ts&external"
export * from "./TmsIndex.ts?vue&type=script&lang=ts&external"
import style0 from "./TmsIndex.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports